export default class Graphics extends PIXI.Graphics{
  constructor(data) {
    super()
    this._data = data
    this.updateDraw()

  }

  get data(){
    return this._data
  }

  updateDraw(){
    const data = this.data

    this.beginFill(data.color ? data.color : 0x000000)
    this.alpha = data.alpha == undefined ? 1 : data.alpha

    if (data.polygon) {
      this.drawPolygon(data.polygon)
    }
    else if (data.round) {
      this.drawRoundedRect(data.x, data.y, data.width, data.height, data.round)
    }
    else {
      this.drawRect(data.x, data.y, data.width, data.height)
    }

    this.endFill()
  }
}
